import { createActions } from 'redux-actions';
import * as types from './types';

export default createActions({}, ...Object.values(types));
